<template>
    <div>
        <Head title="Створити Блоки риболовлі"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('blocks.index')"
            >
                Блоки риболовлі
            </Link>
            <span class="text-indigo-400 font-medium">/</span> Створення блока
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <select-input v-model="form.lake_id" :error="form.errors.lake_id" class="pb-8 pr-6 w-full"
                                      label="Озеро">
                            <option :value="null"/>
                            <option v-for="lake in lakes" :key="lake.id" :value="lake.id">{{ lake.name }}</option>
                        </select-input>
                        <text-input v-model="form.start_date" :error="form.errors.start_date" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Початок блокування" type="date"/>
                        <text-input v-model="form.end_date" :error="form.errors.end_date" class="pb-8 pr-6 w-full lg:w-1/2"
                                        label="Завершення блокування" type="date"/>
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити блок
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout.vue'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import DragAndDrop from "@/Shared/DragAndDrop.vue";
import TextareaInput from "@/Shared/TextareaInput.vue";

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    props: {
        lakes: Array,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                start_date: '',
                end_date: '',
                lake_id: null,
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('blocks.store'))
        },
    },
}
</script>
